export default function guest({ next, store }) {
  if (getCookie('jwt') !== localStorage.getItem('token')) {
    //force logout
    store.dispatch('auth/doLogout')
  }
  //eslint-disable-next-line
  // console.log('pasok guest middleware')
  if (store.getters.auth) {
    return next({
      name: 'dashboard'
    })
  }

  return next()
}

function getCookie(name) {
  const cookies = document.cookie.split('; ')
  for (let cookie of cookies) {
    const [cookieName, cookieValue] = cookie.split('=')
    if (cookieName === name) {
      return decodeURIComponent(cookieValue)
    }
  }
  return null
}
